<template>
  <section id="about" class="hw-section">
    <div class="hw-container hw-about-grid">
      <div class="hw-about-copy">
        <p class="hw-kicker">A empresa</p>
        <h2 class="hw-title">Sobre a Hardwired</h2>
        <p>
          A Hardwired Digital Solutions, Lda é uma empresa de software fundada em fevereiro de 2024,
          a partir do projeto MKGest iniciado em setembro de 2020. Especializamo-nos em soluções digitais
          personalizadas: websites, aplicações móveis e plataformas, para impulsionar o negócio dos nossos clientes.
        </p>
        <p>
          Acreditamos que o vosso sucesso é o nosso. Trabalhamos para relações longas, baseadas em confiança,
          integridade e resultados que se sentem no dia a dia da operação.
        </p>
      </div>
      <div class="hw-stats">
        <div class="hw-stat">
          <strong>2020</strong>
          <span>Nascimento do MKGest</span>
        </div>
        <div class="hw-stat">
          <strong>2024</strong>
          <span>Fundação da Hardwired</span>
        </div>
        <div class="hw-stat">
          <strong>+40</strong>
          <span>Clientes no MKGest</span>
        </div>
        <div class="hw-stat">
          <strong>V.N. Famalicão</strong>
          <span>Portugal</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "About",
};
</script>
